import Details from './_Details'

export default Details
